var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourceResearch = function SvgResourceResearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.5 13.5h6M2.25 16.5h13.5M10.5 16.5a5.25 5.25 0 1 0 0-10.5h-.75M6.75 10.5h1.5M6.75 9a1.5 1.5 0 0 1-1.5-1.5v-3h4.5v3A1.5 1.5 0 0 1 8.25 9zM9 4.5V2.25a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75V4.5"
  })));
};
export default SvgResourceResearch;